import { render } from "./HowItWorksSection.vue?vue&type=template&id=42a2cb4d&scoped=true"
import script from "./HowItWorksSection.vue?vue&type=script&lang=js"
export * from "./HowItWorksSection.vue?vue&type=script&lang=js"

import "./HowItWorksSection.vue?vue&type=style&index=0&id=42a2cb4d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-42a2cb4d"

export default script